var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a",
    width: "137.5%",
    height: "137.5%",
    x: "-18.8%",
    y: "-15%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__b",
    cx: 16,
    cy: 16,
    r: 13.333
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#prefix__a)",
    xlinkHref: "#prefix__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#prefix__b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E40000",
    fillRule: "nonzero",
    d: "M12.76 24c.52 0 1.136-.124 1.831-.369 1.04-.366 1.864-.873 2.66-1.364l.215-.132c.884-.548 1.722-1.163 2.507-1.84 1.871-1.595 2.993-3.16 3.637-5.072.26-.774.63-2.285.177-3.702-.327-1.027-.998-1.916-1.906-2.525C21.775 8.91 20.611 8 18.415 8c-2.007 0-4.208.756-6.542 2.247l-.074.047-.012.007c-.067.04-.133.08-.208.128-.057.043-.118.082-.18.117-.473.313-.926.654-1.356 1.022-.986.929-2.11 2.483-2.04 3.803.015.534.276 1.033.711 1.358.426.313.949.475 1.482.46 1.195 0 2.506-.636 3.402-1.173.055-.037.111-.074.17-.111l.468-.304.153-.1c1.274-.833 2.59-1.694 4.077-2.197.33-.12.678-.185 1.03-.192.15-.001.3.015.445.048.43.083.793.36.98.746.344.683.262 1.763-.206 2.75-.64 1.345-1.738 2.671-3.262 3.942-.658.564-1.372 1.06-2.133 1.484l-.057.03c-.318.18-.648.337-.988.471l-.048.018c-.106.038-.195.071-.277.099-1.491.389-.584-.891-.584-.891.317-.356.657-.692 1.018-1.006.203-.183.41-.373.62-.58l.046-.045c.26-.254.617-.601.595-1.101-.03-.661-.718-1.075-1.365-1.092h-.048c-.623 0-1.213.356-1.598.656-.418.335-.779.733-1.07 1.177-.397.614-1.232 2.178-.419 3.428.325.501.869.754 1.615.754z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelco);
export default __webpack_public_path__ + "static/media/telco.d55207d38cd960009b3fc13fda492af5.svg";
export { ForwardRef as ReactComponent };